var productComponent = (function () {
    var productTabsWrapper = document.querySelector('.product-section__tabs'),
        productTabs = document.querySelectorAll('.product-section__tabs-btn[role="tab"]'),
        productPanel = document.querySelectorAll('.product-section__content-box[role="tabpanel"]'),
        sectionTitle = document.getElementById('product-section__heading').textContent,
        panelMainParent = document.getElementById('product-section-wrapper'),
        tabsMoreThanTwo = document.querySelector('.product-section__tabs-count3'),
        getProductTabName, tabAmpEventName, tabAmpEventProperties, tabAmpJson,
        timeOutNumber = 500,
        eventProductHoverFlag = [], 
        isTabletMob = window.innerWidth < 980;

    return {
        init: init,
    };

    function init() {
        if (productTabs.length && productPanel.length) {
            // For easy reference
            var keys = {
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                delete: 46,
                enter: 13,
                space: 32,
            };

            // Add or subtract depending on key pressed
            var direction = {
                37: -1,
                38: -1,
                39: 1,
                40: 1,
            };

            // Bind listeners for product component
            for (var i = 0; i < productTabs.length; ++i) {
                setEventsOnProductTabs(i);
            }

            function setEventsOnProductTabs(index) {
                productTabs[index].addEventListener('click', setClickEvtOnProductTab);
                productTabs[index].addEventListener('keydown', setKeydownEvtOnProductTab);
                productTabs[index].addEventListener('keyup', setKeyupEvtOnProductTab);
                productTabs[index].addEventListener('mouseover', setMouseoverEvtOnProductTab);

                // Build an array with all tabs (<button>s) in it
                productTabs[index].index = index;
            }

            // When a tab is clicked, activateTab is fired to activate it
            function setClickEvtOnProductTab(event) {
                var tab = event.target;
                activateProductTab(tab, false);
            }

            // Handle keydown on Product tabs
            function setKeydownEvtOnProductTab(event) {
                var key = event.keyCode;

                switch (key) {
                    case keys.end:
                        event.preventDefault();
                        // Activate last tab
                        focusProductLastTab();
                        break;
                    case keys.home:
                        event.preventDefault();
                        // Activate first tab
                        focusProductFirstTab();
                        break;
                    default:
                }
            }

            // Handle keyup on Product tabs
            function setKeyupEvtOnProductTab(event) {
                var key = event.keyCode;
                switch (key) {
                    case keys.up:
                    case keys.down:
                        if (!isTabletMob) {
                            switchProductTabOnArrowPress(event);
                        }
                        break;
                        
                    case keys.left:
                    case keys.right:        
                        if (isTabletMob) {
                            switchProductTabOnArrowPress(event);
                        }
                        break;
                    case keys.enter:
                    case keys.space:
                        activateProductTab(event.target);
                        break;
                    default:
                }
            }

            // Either focus the next, previous, first, or last tab
            // depending on key pressed
            function switchProductTabOnArrowPress(event) {
                var pressed = event.keyCode;
                if (direction[pressed]) {
                    var target = event.target;
                    if (typeof target.index !== 'undefined') {
                        if (productTabs[target.index + direction[pressed]]) {
                            productTabs[target.index + direction[pressed]].focus();
                        } else if (pressed === keys.left || pressed === keys.up) {
                            focusProductLastTab();
                        } else if (pressed === keys.right || pressed == keys.down) {
                            focusProductFirstTab();
                        }
                    }
                }
            }

            // Activates any given tab panel
            function activateProductTab(tab, setFocus) {
                setFocus = setFocus || true;

                // Deactivate all other tabs
                deactivateProductTabs();

                // Remove tabindex attribute
                tab.removeAttribute('tabindex');

                // Set the tab as selected
                tab.setAttribute('aria-selected', 'true');

                //set active to parent element
                tab.parentElement.classList.add('product-section__tabs-child--active');

                // Get the value of aria-controls (which is an ID)
                var panelControl = tab.getAttribute('aria-controls'),
                    panelControlDom = document.getElementById(panelControl),
                    panelTriggerElem = panelControlDom.parentElement;

                //scroll Product Panel into viewport
                var productSecMainSection = document.getElementById('productSecMainSection'),
                    mainSectionElem = document.getElementById('product-section-main'),
                    offsetTop = mainSectionElem ? mainSectionElem.offsetTop + 120 : 0,
                    moboffsetTop = productSecMainSection.getBoundingClientRect().top + window.scrollY - 40,
                    stickyNavBar = document.getElementById('support-cat-nav');
                
                if (stickyNavBar) {
                    moboffsetTop = moboffsetTop - stickyNavBar.offsetHeight;
                }
                
                window.scroll({    
                    top: moboffsetTop,
                    behavior: 'smooth'
                });

                window.addEventListener("scroll", function (event) {
                    // fixed position check so that there is no flicker
                    timeOutNumber = (window.pageYOffset === moboffsetTop) ? 0 : 500;
                });

                if (panelControlDom) {
                    panelControlDom.setAttribute('aria-hidden', 'false');
                    var offsetTop = panelTriggerElem ? panelTriggerElem.offsetTop : 0,
                        offsetLeft = panelTriggerElem ? panelTriggerElem.offsetLeft : 0,
                        tabOffsetLeft = tab ? tab.offsetLeft : 0,
                        cardsWrapperHeight = panelControlDom.offsetHeight,                 
                        panelActiveAnchorElem = panelControlDom.querySelectorAll('a.product-section__content-cards');
                    
                    //setting same height for 2nd and 3rd tab content
                    if (panelControl == 'product-tab-content2') {
                        var secondTabContentHeight = document.querySelector('#product-tab-content1');
                            cardsWrapperHeight = secondTabContentHeight.offsetHeight;
                    }

                    for (var l = 0; l < panelActiveAnchorElem.length; l++) {
                        panelActiveAnchorElem[l].removeAttribute('tabindex');
                    }

                    //scroll Product Panel into viewport
                    setTimeout(function () {
                        if (!isTabletMob) {
                            fnScrollElemInViewport(panelMainParent, offsetTop, 10, isTabletMob);
                        } else {
                            fnScrollElemInViewport(productTabsWrapper, tabOffsetLeft, 10, isTabletMob); //scroll tabs horizotally
                            fnScrollElemInViewport(panelMainParent, offsetLeft, 10, isTabletMob);
                        }
                    }, timeOutNumber);

                    if (window.innerWidth < 640 && tabsMoreThanTwo) {
                        //set tabwrapper height dynamically
                        panelMainParent.style.height = cardsWrapperHeight + 'px';
                    }
                }

                // Set focus when required
                if (setFocus) {
                    tab.focus();
                }

                //show images from lazy load
                lazyLoading.show();

                //fire Amplitude events
                getProductTabName = tab.getAttribute('title');
                tabAmpEventName = tab.getAttribute("data-tab-eventname");    
                tabAmpEventProperties = tab.getAttribute("data-tab-ampjson");
                
                if (tabAmpEventName && tabAmpEventProperties) {
                    tabAmpJson = bsLib.JSONParse(tabAmpEventProperties);
                }

                WebEventTracker.logEvent(EDS.webEvents, tabAmpEventName, bsLib.extend({
                    action: 'Click',
                    'section': sectionTitle,
                    product: getProductTabName + ' Tab',
                    location: getProductTabName,
                    'signedin': (Cookie.read('bs_logging_id') ? true : false),
                },
                    tabAmpJson,
                    ((popUpCSFOptions.vwoShow) ? { source: popUpCSFOptions.source } : {})
                ));
            }

            function fnScrollElemInViewport(element, to, duration, isTabletMob) {
                var start;
                if (!isTabletMob) { 
                    start = element.scrollTop;
                } else {
                    start = element.scrollLeft;
                }
                var change = to - start,
                    currentTime = 0,
                    increment = 5;

                var animateScrollFn = function () {
                    currentTime += increment;
                    var val = Math.easeInOutQuad(currentTime, start, change, duration);
                    if (!isTabletMob) { 
                        element.scrollTop = val;
                    } else {
                        element.scrollLeft = val;
                    }
                    if (currentTime < duration) {
                        setTimeout(animateScrollFn, increment);
                    }
                };
                animateScrollFn();
            }

            //t = current time
            //b = start value
            //c = change in value
            //d = duration
            Math.easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;
                return -c / 2 * (t * (t - 2) - 1) + b;
            };

            // Deactivate all tabs and tab panels
            function deactivateProductTabs() {
                for (var j = 0; j < productTabs.length; j++) {
                    productTabs[j].setAttribute('tabindex', '-1');
                    productTabs[j].setAttribute('aria-selected', 'false');
                    productTabs[j].parentElement.classList.remove('product-section__tabs-child--active');
                }

                for (var k = 0; k < productPanel.length; k++) {
                    productPanel[k].setAttribute('aria-hidden', 'true');
                    var panelAnchorElem = productPanel[k].querySelectorAll('a.product-section__content-cards');
                    for (var l = 0; l < panelAnchorElem.length; l++) {
                        panelAnchorElem[l].setAttribute('tabindex', '-1');
                    }
                }
            }

            // Make a guess
            function focusProductFirstTab() {
                productTabs[0].focus();
            }

            // Make a guess
            function focusProductLastTab() {
                productTabs[productTabs.length - 1].focus();
            }

            //Attach Amplitude click events on links
            var productLinkElem = document.querySelectorAll('a.product-section__content-cards');
            for (var i = 0; i < productLinkElem.length; i++) {
                productLinkElem[i].addEventListener("click", function () {
                    var that = this;
                    sendProductTabLinkEvents(that, 'Click');
                });

                //Attach Hover events on tab links section
                productLinkElem[i].addEventListener("mouseover", function () {
                    var that = this;
                    if (!eventProductHoverFlag.includes(that)) {
                        sendProductTabLinkEvents(that, 'Hover');
                        eventProductHoverFlag.push(that);
                    }
                });
            }

            function sendProductTabLinkEvents(elem, eventAction) {
                var getCurrentActiveTabElem = document.querySelector('.product-section__tabs-child--active button'),
                    cardEventName = elem.getAttribute('data-tab-eventname'),
                    cardAmpEventProperties = elem.getAttribute("data-tab-ampjson"),
                    cardAmpJson;
                
                    if (cardEventName && cardAmpEventProperties) {
                        cardAmpJson = bsLib.JSONParse(cardAmpEventProperties);
                    }
                
                WebEventTracker.logEvent(EDS.webEvents, cardEventName, bsLib.extend({
                    action: eventAction,
                    'section': sectionTitle,
                    product: elem.getAttribute('title') + ' Product',
                    location: getCurrentActiveTabElem.getAttribute('title'),
                    'destination url': elem.getAttribute('href'),
                    'signedin': (Cookie.read('bs_logging_id') ? true : false),
                },
                    cardAmpJson,
                    ((popUpCSFOptions.vwoShow) ? { source: popUpCSFOptions.source } : {})
                ));
            }

            function setMouseoverEvtOnProductTab() {
                var that = this,
                    getActiveProductTabName = that.getAttribute('title');

                tabAmpEventName = that.getAttribute("data-tab-eventname");    
                tabAmpEventProperties = that.getAttribute("data-tab-ampjson");
                
                if (tabAmpEventName && tabAmpEventProperties) {
                    tabAmpJson = bsLib.JSONParse(tabAmpEventProperties);
                }
                
                if (!eventProductHoverFlag.includes(that)) {
                    WebEventTracker.logEvent(EDS.webEvents, tabAmpEventName, bsLib.extend({
                        action: 'Hover',
                        product: getActiveProductTabName + ' Tab',
                        location: getActiveProductTabName,
                        'section': sectionTitle,
                        'signedin': (Cookie.read('bs_logging_id') ? true : false),
                    },
                       tabAmpJson,
                        ((popUpCSFOptions.vwoShow) ? { source: popUpCSFOptions.source } : {})
                    ));
                    eventProductHoverFlag.push(that);
                }
            }

            window.addEventListener('resize', function () {
                window.innerWidth >= 640 ? panelMainParent.style.height = '' : '';
            });
        }
    }
})();

productComponent.init();